<sgt-select
  [options]="semanasSelectOptions"
  [settings]="settingsSelectSemana"
  name="semana"
  id="semana"
  (selectedValueChanged)="onChangeSemana($event)"
>
</sgt-select>
